import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import URI from 'urijs';
import { useCtrLogger } from '@bingads-webui-campaign/reports-v4-telemetry';
import { getRoutePathById, siteMapPropType, withSiteMap, processor } from '@bingads-webui-campaign-react/with-site-map';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { Link as LinkButton } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getInsertionOrderDetailsCellStyles } from '../styles';

export function InsertionOrderDetailsBase({
  siteMap,
  insertionOrderDetailValue,
  insertionOrderId,
  accountId,
}) {
  const classes = useDefaultStyles(getInsertionOrderDetailsCellStyles);
  const { scope: { values: { cid, aid, uid } } } = useContext(ScopeContext);
  const ctrLogger = useCtrLogger('ReportsV4PreviewReport');

  const ioHistoryLink = useMemo(() => {
    const pathname = getRoutePathById(siteMap, 'ioViewHistory');
    const searchParams = {
      aid,
      cid,
      uid,
      orderId: insertionOrderId,
      accountId,
    };

    const link = new URI(pathname).addSearch(searchParams).toString();
    return link;
  }, [cid, aid, uid, insertionOrderId, accountId]);

  const onClickLink = () => {
    ctrLogger.click({ target: 'insertionOrderDetail', extraData: { reportType: 'insertionOrderReport', insertionOrderId, insertionOrderDetailValue } });
    return true;
  }

  return (
    <div className={classnames('insertion-order-details-cell')}>
      <LinkButton
        className={classnames('insertion-order-details-button', classes.InsertionOrderDetailsButton)}
        key={`${insertionOrderDetailValue}-${insertionOrderId}`}
        target="_blank"
        href={ioHistoryLink}
        onClick={onClickLink}
      >
        {insertionOrderDetailValue}
      </LinkButton>
    </div>
  );
}

InsertionOrderDetailsBase.propTypes = {
  siteMap: siteMapPropType.isRequired,
  insertionOrderDetailValue: PropTypes.string.isRequired,
  insertionOrderId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

InsertionOrderDetailsBase.defaultProps = {
};

export const InsertionOrderDetailsCell = withSiteMap(
  InsertionOrderDetailsBase,
  [processor.processPermissions, processor.processPath]
);
